<div *ngIf="currentUserMode == 'provider'">
  <div class="d-flex flex-column align-items-start align-self-stretch gap-4 p-3 w-100"
    style="background: var(--neutral-white, #FFF);">

    <div class="d-flex justify-content-between align-items-center align-self-stretch pb-3 border-bottom border-2">
      <div class="fs-5 fw-bold"> Account Transactions</div>
    </div>

    <div class="d-flex align-items-center bg-info-subtle p-4 gap-2 w-100">
      <span><i class="bi bi-info-circle-fill text-info fs-4"></i></span>
      <span class="flex-wrap">
        Truckit Pay remittances (payouts) occur in batches, meaning a payment
        you received in your bank may include funds for multiple completed jobs.
        Do you need to reconcile with your bank statement or need help using this
        feature? <a href="https://help.truckit.net/support/solutions/articles/35000175754-what-is-the-truckit-reference-number-on-my-bank-statement-" target="_blank">
          Learn more here.
        </a>
      </span>
    </div>

    <ul class="nav nav-tabs w-100">
      <li class="nav-item">
        <a class="nav-link active" aria-current="page" href="#">Transactions</a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" href="#">Remittance</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">Banking</a>
      </li> -->
    </ul>

    <app-transactions class="w-100"></app-transactions>
  </div>
</div>
<div *ngIf="currentUserMode == 'customer'">
  <app-financial-report></app-financial-report>
</div>